import { bootstrapResponsiveBreakpoints } from '@teetsh/app/src/utils/constants';
import useIsBelowSize from './useIsBelowSize';

export default () => useIsBelowSize(bootstrapResponsiveBreakpoints.md);
